import React, { Component } from "react";
import { HashLink as Link } from 'react-router-hash-link';

class Banner extends Component {
    render() {
        return (
            //            <div className="cm-banner overlay bg-cover" style={{backgroundImage: "url(assets/images/bg-banner.jpg)"}}>
            <div className="cm-banner overlay bg-cover" style={{ backgroundImage: "url(assets/images/BaseballGame.jpeg)" }}>
                <div className="container h-100">
                    <div className="row h-100 align-items-center">
                        <div className="col-xl-12 col-lg-12">
                            <div className="block text-white">
                                <div className="col-xl-6 col-lg-7">
                                <h2 className="display-3">Fiorentina Baseball e Softball</h2>
                                </div>
                                <div>
                                    <Link to='/teams' className="btn btn-primary mt-10 mr-3 mr-md-4 initiate-scripts text-white" spy="true" smooth="true">Le nostre squadre</Link>
                                    <Link to="/home#ContactUs" className="btn btn-primary mt-10 mr-3 mr-md-4 initiate-scripts text-white" spy="true" smooth="true">Contattaci</Link>
                                    <Link to="/home#news" className="btn btn-primary mt-10 mr-3 mr-md-4 initiate-scripts text-white" spy="true" smooth="true">Le nostre notizie</Link>
                                    <Link to="/home#trainingTimetable" className="btn btn-primary mt-10 mr-3 mr-md-4 initiate-scripts text-white" spy="true" smooth="true">Vieni A Giocare Con Noi</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Banner;